import { Component } from '@angular/core';

@Component({
  selector: 'app-nopage',
  imports: [],
  templateUrl: './nopage.html',
  styleUrl: './nopage.scss'
})
export class Nopage {

}
